import vueComponentOptions from 'components/InputSelect.vue';

const SelectInput = Vue.extend(vueComponentOptions);

module.exports = SelectInput;
